import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { _O } from "../../modules/utils";
import { setCookie, setCookieWs } from "../../modules/utils/cookie";
import ArrowImg from "../../resources/images/icon/icon_back_black.png";
import { PostApi109, PostApiLoginLog } from "./../../modules/network/padoPost";
import { SnsLoginContentsArea } from "./Components/SnsLoginContentsArea";

import BgImage1 from "../../resources/images/main/login_bg_splash01.png";
import BgImage2 from "../../resources/images/main/login_bg_splash02.png";
import BgImage3 from "../../resources/images/main/login_bg_splash03.png";
import BgImage4 from "../../resources/images/main/login_bg_splash04.png";

import { useContext } from "react";
import { NativeAction } from "../../modules/utils/HandleWs";
import appleLogo from "../../resources/images/icon/login/apple_logo.png";
import backArrow from "../../resources/images/icon/login/back_arrow.svg";
import kakaoLogo from "../../resources/images/icon/login/kakao_logo.png";
import naverLogo from "../../resources/images/icon/login/naver_logo.png";
import {
  AppContext,
  SocketCommand,
  socketManager,
} from "./../../components/AppProvider";
import useTitle from "../../modules/hooks/useTitle";

export default () => {
  const [imgCnt, setImgCnt] = useState(0);
  const { phonecfg } = useContext(AppContext);
  useTitle("로그인_메인");
  const goSnsLogin = param => {
    // setCookie("isAutologin", isAutoLogin, 365);
    setCookie("authCheck", "", -1);

    if (param === "KAKAO") {
      setCookie("signUpChannel", "400", 1);
      setCookieWs({ isAutologin: true, signUpChannel: "400" });
      window.location.href = "ep://login/kakao";
    }

    if (param === "NAVER") {
      setCookie("signUpChannel", "100", 1);
      setCookieWs({ isAutologin: true, signUpChannel: "100" });
      window.location.href = "ep://login/naver";
    }

    if (param === "APPLE") {
      setCookie("signUpChannel", "600", 1);
      socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
    }
  };

  const appleLoginAf = (userEmail, userName, UID, signUpChannel) => {
    setCookieWs({ isAutologin: true, signUpChannel: "600" });
    if (userEmail && userEmail != null) {
      _O.Open(
        "/membership/snsLogin/" +
          userEmail +
          "/" +
          userName +
          "/" +
          UID +
          "/" +
          signUpChannel
      );
    } else {
      _O.Open("/membership/appleLogin/" + UID + "/" + signUpChannel);
    }
  };

  useEffect(() => {
    if (imgCnt != 0) {
      $("#BgImage" + imgCnt).removeClass("zoom-in-out-box");
    }

    $("#BgImage" + (imgCnt + 1)).addClass("zoom-in-out-box");

    setTimeout(() => {
      if (imgCnt == 3) {
        $("#BgImage4").removeClass("zoom-in-out-box");
        setImgCnt(0);
      } else {
        setImgCnt(imgCnt + 1);
      }
    }, [7000]);
  }, [imgCnt]);

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
  }, []);
  return (
    <>
      <ContainerLogin>
        <img id="BgImage1" src={BgImage1} className={"imsi"} />
        <img id="BgImage2" src={BgImage2} className={"imsi"} />
        <img id="BgImage3" src={BgImage3} className={"imsi"} />
        <img id="BgImage4" src={BgImage4} className={"imsi"} />
        <img id="BgImage1" src={BgImage1} className={"imsi imsi2"} />

        <FixedArea>
          <LoginBox>
            {/* 로그인 회원가입 */}
            <div style={{ display: "flex" }}>
              <h2>로그인</h2>
              <BtnRegist
                onClick={() => _O.OpenMenu("/membership/userPhoneCheck")}>
                회원가입
              </BtnRegist>
            </div>

            {/* SNS 로그인 버튼 */}
            <SnsLoginContentsArea>
              <div
                style={{
                  padding: "12px 0px",
                }}>
                <div
                  style={{
                    width: "100%",
                    height: "50px",
                    backgroundColor: "#FDDC3FFF",
                    borderRadius: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    font: "bold 16px/50px 고딕체",
                    marginBottom: "9px",
                    color: "black",
                  }}
                  onClick={() => goSnsLogin("KAKAO")}>
                  <img
                    src={kakaoLogo}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "25px",
                      marginRight: "20px",
                    }}
                  />{" "}
                  카카오 로그인
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "50px",
                    backgroundColor: "#03C75AFF",
                    borderRadius: "30px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    font: "bold 16px/50px 고딕체",
                    marginBottom: "9px",
                    color: "white",
                  }}
                  onClick={() => goSnsLogin("NAVER")}>
                  <img
                    src={naverLogo}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "20px",
                      marginRight: "20px",
                    }} // width: "20px", height: "20px", verticalAlign: "middle", paddingRight: "17px"//, paddingLeft: "1px"//, transform:"scale(1.5)" }}
                  />{" "}
                  네이버 로그인
                </div>
                {phonecfg.phoneOS === "IOS" && (
                  <div
                    style={{
                      width: "100%",
                      height: "50px",
                      backgroundColor: "#000000FF",
                      borderRadius: "30px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      font: "bold 16px/50px 고딕체",
                      marginBottom: "9px",
                      color: "white",
                    }}
                    onClick={() => goSnsLogin("APPLE")}>
                    <img
                      src={appleLogo}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "30px",
                        marginRight: "32px",
                        marginLeft: "-5px",
                      }}
                    />{" "}
                    애플 로그인
                  </div>
                )}
              </div>
            </SnsLoginContentsArea>

            {/* 다른 방법으로 로그인 */}
            <div
              style={{ display: "flex" }}
              onClick={() => _O.OpenMenu("/membership/loginAccount")}>
              <div style={{ font: "bold 13px/26px 고딕체" }}>
                <h3>아이디로 로그인</h3>
              </div>
              <div
                style={{
                  display: "flex",
                  margin: "auto 0px",
                  marginLeft: "10px",
                }}>
                <img
                  src={ArrowImg}
                  style={{
                    transform: "rotate(180deg)",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />
              </div>
            </div>
          </LoginBox>
        </FixedArea>
        <div
          style={{ position: "absolute", top: "2%", left: "2%" }}
          onClick={() => _O.Open("/")}>
          <img
            src={backArrow}
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      </ContainerLogin>
    </>
  );
};

const ContainerLogin = styled.div`
  position: relative;
  background-color: black;
  height: 100vh;
  overflow: hidden;
`;

const FixedArea = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0px;
`;

const LoginBox = styled.div`
  border-radius: 7px;
  background-color: #fff;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 20px 17px;

  bottom: 0px;
`;

const BtnRegist = styled.div`
  // border: 1px solid black;
  border: 1px solid #7715ff;
  border-radius: 7px;
  color: #7715ff;
  margin-left: auto;
  line-height: 31.5px;
  padding: 0px 10px;
  font-weight: 500;
`;

// logType : I(로그인) O(로그아웃)
// procType : A(자동) M(수동)
// scrptTypeCd : signUpChannel
export const loginLogInterface = (
  userinfo,
  phonecfg,
  cfg,
  logType,
  procType,
  scrptTypeCd
) => {
  if (logType === "I") {
    PostApiLoginLog(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then(res => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch(err => {
        // handleLoginFail();
      });
  } else {
    PostApi109(userinfo, phonecfg, cfg, logType, procType, scrptTypeCd)
      .then(res => {
        if (res.resultCode === "000") {
        } else {
        }
      })
      .catch(err => {
        // handleLoginFail();
      });
  }
};
